import * as constants from './constants'

export const changeSearchParams = value => ({
  type: constants.CHANGE_SEARCH_PARAMS,
  value
})
